// import Keycloak from "keycloak-js";
import Keycloak from "./keycloak-js";

const kc = new Keycloak('/keycloak.json');

export default kc;
